module.exports = __webpack_public_path__ + "static/media/id_verification.099d4871.svg";